"use client";

import Script from "next/script";

export default function AttentiveTagScript() {
  return (
    <>
      <Script id="attentive-tag" src="https://cdn.attn.tv/gin-gb/dtag.js" />
    </>
  );
}
